// @flow
export function extractSubdomain(domain: string) {
  const s = domain.split('.');
  return s[0];
  // s.pop();
  // s.pop();
  // return s.join('.');
}

export function extractRootDomain(domain: string) {
  const s = domain.split('.');
  if (s.length <= 2) return domain;
  // eslint-disable-next-line no-unused-vars
  const [f, ...rest] = s;
  return rest.join('.');
  // return [s[s.length - 2], s[s.length - 1]].join('.');
}

export const capitalize = (s: string) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getParsedMarkdownText = (markdownText: string) => {
  const parsedText = markdownText
    .replace(/^### (.*$)/gim, '<h3>$1</h3>')
    .replace(/^## (.*$)/gim, '<h2>$1</h2>')
    .replace(/^# (.*$)/gim, '<h1>$1</h1>')
    .replace(/^> (.*$)/gim, '<blockquote>$1</blockquote>')
    .replace(/\*\*(.*)\*\*/gim, '<b>$1</b>')
    .replace(/\*(.*)\*/gim, '<i>$1</i>')
    // .replace(/!\[(.*?)\]\((.*?)\)/gim, "<img alt='$1' src='$2' />")
    // .replace(/\[(.*?)\]\((.*?)\)/gim, "<a href='$2'>$1</a>")
    .replace(/\n/g, '<br>');

  return parsedText.trim();
};

/**
 *
 * @param {RegExp} patternRegex regex pattern to match
 * @param {string} text text to replace
 * @param {Object} data data to replace
 * @returns string
 *
 * @example
 *
 *  const text = 'Hello {{name}} {{lastName}} 🖐';
 *  const data = {name: 'John', lastName: 'Doe'};
 *  const regex = /{{([^}]+)}}/g;
 *
 *  replaceTextPattern(regex, text, data);
 *  // returns 'Hello John Doe 🖐'
 */
export function replaceTextPattern(
  patternRegex: RegExp,
  text: string,
  data: {[string]: string}
): string {
  return text.replace(patternRegex, (match, variable): string => {
    return data[variable.trim()] || match;
  });
}

export function stringToSafeLink(text: string): string {
  if (!text) return '';

  const trimmed = text.trim();

  const normalized = trimmed
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  const parsed = normalized
    .replace(/ /g, '-')
    .replace(/_/g, '-')
    .replace(/[^\w-]+/g, '');

  return window.encodeURI(parsed);
}

export class StringMutable {
  value: string;

  constructor(initialValue: string = '') {
    this.value = initialValue;
  }

  concat(...args: string[]): StringMutable {
    this.value += args.join('');
    return this;
  }

  toString(): string {
    return this.value;
  }
}

export function sanitizeAlphanumeric(value: string): string {
  if (!value) return '';
  return value
    .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ0-9\s.,#-]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
